/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { ImageURL } from "../../../../Environment/Environment";
import defaultImg from "../../../../assets/img/thumbnail.png";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";
import Pagination from "../../../../Helper/Pagination";

export default function EdgeListing() {
  const [currentPage, setCurrentPage] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);
  const [Edgelist, setEdgelist] = useState();
  const [Title, setTitle] = useState("");
  const [status, setstatus] = useState("");
  const [Image, setImage] = useState("");
  const [ImgPath, setLocalImgPath] = useState("");
  const [price, setprice] = useState("");
  const [description, setdescription] = useState("");
  const [selectedState, setselectedState] = useState("");
  const [availableIn, setAvailableIn] = useState([]);

  useEffect(() => {
    getEdgeList();
  }, [search_key, currentPage]);

  const getEdgeList = () => {
    setLoading(true);
    GetService(`${API_URL.EDGE_LISTING}?search_key=${search_key}`).then(
      (res) => {
        console.log(res?.data);
        if (res.data.status === true) {
          setEdgelist(res?.data?.data);
          // SetTotalPageCount(res.data.totalPages);
          // SetTotalCount(res.data.totalItems);
          // setCount(res.data.currentPage * param.limit);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  const onimageUpload = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setLocalImgPath(window.URL.createObjectURL(e.target.files[0]));
    }
  };

  useEffect(() => {
    setTitle(selectedState?.name);
    setLocalImgPath(selectedState?.image);
    setImage(selectedState?.image);
    setdescription(selectedState?.description);
    setprice(selectedState?.price);
    setstatus(selectedState?.status); 
    if (selectedState?.availableIn?.length) {
      // for (let i = 0; i < selectedState?.availableIn?.length; i++) {
      //   const element = selectedState?.availableIn[i];
      //   console.log(element)
      //   availableIn.push(element)
      // }
      setAvailableIn(selectedState.availableIn);
    }else setAvailableIn([])
  }, [selectedState]);

  const submit = (e) => {
    e.preventDefault();
    if (!Title || !Image) {
      setError(true);
      return;
    }
    setsubmitLoader(true);
    const formdata = new FormData();
    formdata.append("name", Title);
    formdata.append("id", selectedState?.edgeimageid);
    formdata.append("status", status);
    formdata.append("image", Image);
    formdata.append("description", description);
    formdata.append("price", price);
    formdata.append("availableIn", `[${availableIn}]`);

    PostFormData(API_URL.UPDATE_EDGE_LISTING, formdata).then(
      (res) => {
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getEdgeList);
          resetFunc();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  function resetFunc() {
    setTitle("");
    setImage("");
    setLocalImgPath(defaultImg);
    setError(false);
    setsubmitLoader(false);
  }
 
  const handleCheckboxChange2 = (type) => {
    setAvailableIn((prev) => {
      if (prev.includes(type)) {
        // If type is already in the array, remove it
        return prev.filter((item) => item !== type);
      } else {
        // If type is not in the array, add it
        return [...prev, type];
      }
    });
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Edges List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Edges List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div class="card">
                <div class="card-body">
                  {/* <div className="align-items-center d-flex justify-content-end row">
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div> */}

                  <div class="table-responsive mt-3">
                    {!loading && (
                      <table class="table table-hover table-bordered table-striped">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Image</th>
                            <th className="text-center">Title</th>
                            <th className="text-center">Description</th>
                            <th className="text-center">Price ($)</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Edgelist?.map((item, i) => (
                            <tr key={i}>
                              <td className="text-center">{i + 1}</td>
                              <td className="text-center">
                                <img
                                  src={item?.image}
                                  alt="..."
                                  onError={(e) => {
                                    e.target.src = defaultImg;
                                  }}
                                />
                              </td>
                              <td className="text-center">{item?.name}</td>
                              <td className="text-center">
                                {item?.description}
                              </td>
                              <td className="text-center">{item?.price}</td>
                              <td className="text-center">
                                <span
                                  title="Edit"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setselectedState(item);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                          {Edgelist && Edgelist.length === 0 && (
                            <tr>
                              <td colSpan="6" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    {/* <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit Edges
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Title</label>
                  <input
                    type="text"
                    name="name"
                    value={Title}
                    className="form-control"
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Title"
                  />
                  {error && !Title && (
                    <div className="error">Title cannot be empty</div>
                  )}
                </div>
                <div className="row">
                <div className="col-4 form-group">
                  <label>Price</label>
                  <input
                    type="text"
                    name="name"
                    value={price}
                    className="form-control"
                    onChange={(e) => setprice(e.target.value)}
                    placeholder="price"
                  />
                  {error && !price && (
                    <div className="error">price cannot be empty</div>
                  )}
                </div>
                <div className="col-8 form-group">
      <label>Available In</label>
      <div className="d-flex justify-content-between align-items-center skip">
        <input
          className="me-2"
          type="checkbox"
          name="single_panel"
          id="single_panel"
          onChange={() => handleCheckboxChange2('single_panel')}
          checked={availableIn.includes('single_panel')}
        />
        <span className="mr-2">Single Canvas</span>
        <input
          type="checkbox"
          name="split_canvas"
          id="split_canvas"
          onChange={() => handleCheckboxChange2('split_canvas')}
          checked={availableIn.includes('split_canvas')}
        />
        <span className="mr-2">Split Canvas</span>
      </div>
      <div className="d-flex justify-content-between align-items-center skip">
        <input
          type="checkbox"
          name="story_canvas"
          id="story_canvas"
          onChange={() => handleCheckboxChange2('story_canvas')}
          checked={availableIn.includes('story_canvas')}
          className="skip"
        />
        <span className="mr-2">Story Canvas</span>
        <input
          type="checkbox"
          name="gallery_wall2"
          id="gallery_wall"
          onChange={() => handleCheckboxChange2('gallery_wall')}
          checked={availableIn.includes('gallery_wall')}
        />
        <span className="mr-2" htmlFor="gallery_wall">
          Gallery Wall
        </span>
      </div>
      <div className="">
        <input
          type="checkbox"
          name="diamond_dust"
          id="diamond_dust"
          onChange={() => handleCheckboxChange2('diamond_dust')}
          checked={availableIn.includes('diamond_dust')}  
        />
        <span className="mx-2">Diamond Dust</span>  
      </div>
    </div>


                 {/* <div className="col-8 form-group">
      <label>Available In</label>
      {checkboxes.map((checkbox, index) => (
        <div className="d-flex justify-content-between align-items-center" key={checkbox.id}>
          <input 
            type="checkbox" 
            name={checkbox.id} 
            id={checkbox.id} 
            checked={checkbox.checked} 
            onChange={() => handleCheckboxChange(index)} 
             
          />
          <span 
            className="mr-2" 
            onClick={() => handleCheckboxChange(index)} 
            role="checkbox" 
            aria-checked={checkbox.checked} 
            tabIndex="0"
          >
            {checkbox.label}
          </span>
        </div>
      ))}
    </div> */}

                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    type="text"
                    name="name"
                    value={description}
                    className="form-control"
                    onChange={(e) => setdescription(e.target.value)}
                    placeholder="description"
                  ></textarea>

                  {error && !description && (
                    <div className="error">description cannot be empty</div>
                  )}
                </div>
                <div className="mt-3">
                    <div className="row d-flex align-items-start">
                      <div className="col-md-5 col-6">
                        <span>
                          <span className="btn btn-primary col-12">
                            Select Image
                            <input
                              type="file"
                              name="image"
                              accept=".jpg,.jpeg,.png"
                              className="btn-input position-absolute"
                              style={{ opacity: 0 }}
                              onChange={(e) => onimageUpload(e)}
                            />
                          </span>
                        </span>

                        {error && !Image && (
                          <div className="error mt-1">Image is required</div>
                        )}
                      </div>
                      <div className="col-md-7 col-12">
                        <img
                          src={ImgPath}
                          alt="..."
                          className="CommonImage"
                          onError={(e) => {
                            e.target.src = defaultImg;
                          }}
                        />
                      </div>
                    </div>
                  </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
